import {
  Carousel,
  CarouselContent,
  CarouselControls,
  CarouselItem,
} from '@/components/ui/carousel';
import { cn } from '@/lib/utils';

/*
 * The photo rail used across the About and Special Events pages.
 *
 * The same carousel block — an `h-48 lg:h-96` image with no width control and
 * no dot indicator — was copy-pasted verbatim into eight pages. This is the one
 * copy; those pages adopt it in the follow-up pass.
 */
const ImageGallery = ({
  images,
  alt,
  className,
}: {
  images: string[];
  /** Describes the set; each slide is decorative on its own. */
  alt: string;
  className?: string;
}) => {
  if (images.length === 0) {
    return null;
  }

  return (
    <Carousel
      className={cn('flex w-full flex-col gap-6', className)}
      opts={{ loop: images.length > 2 }}
      aria-label={alt}
    >
      <CarouselContent className="-ml-4">
        {images.map((image) => (
          <CarouselItem
            key={image}
            className="basis-full pl-4 sm:basis-1/2 lg:basis-1/3"
          >
            <div className="aspect-4/3 overflow-hidden rounded-lg bg-muted">
              <img
                className="size-full object-cover"
                src={image}
                alt=""
                width={1200}
                height={900}
                loading="lazy"
              />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselControls />
    </Carousel>
  );
};

export default ImageGallery;
